import { FlexBox, Timestamp } from '@dixa/lib-shared-habla';

import { ConversationsTableSortableField } from 'components/conversation/conversationTable';

import { useConversationRow } from '../../../utils/useConversationRow';

import styles from './conversationsTableTimestamp.module.scss';

type ConversationsTableTimestampProps = {
  timestampKey: ConversationsTableSortableField;
};

/** Represents the content of a timestamp cell in the conversations table. */
export const ConversationsTableTimestamp = ({
  timestampKey,
}: ConversationsTableTimestampProps): JSX.Element => {
  const { conversation } = useConversationRow();
  const timestamp = conversation[timestampKey];

  return (
    <FlexBox display="inline-flex" alignItems="center">
      {timestamp && (
        <Timestamp className={styles.timestamp} time={timestamp} relative />
      )}
    </FlexBox>
  );
};
